import React, { useState } from "react";
import logo from "./img/image 28.svg";
import "./Navbar.css";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdCancel } from "react-icons/md";

const Navbar = ({backgroundColor}) => {
  const [expand, setExpand] = useState(true);

  function handler() {
    setExpand(!expand);
  }

  window.addEventListener("scroll", function () {
    const header = document.querySelector("header");
    header.classList.toggle("sticky", window.scrollY > 0);
  });
  return (
    <div>
      <header className="Navbar" style={{backgroundColor}}>
        <div className="navBar">
          <Link to="/">
            <img src={logo} alt="" className="logo"/>
          </Link>
          <div className={expand ? "navs" : "navs navs-NX"}>
            <Link to="/" className="link" onClick={handler}>
              <h1 className="navTxt">Home</h1>
            </Link>
            <Link to="/services" className="link" onClick={handler}>
            <h1 className="navTxt">Services</h1>
            </Link>
            <Link to="/contact" className="link" onClick={handler}>
            <h1 className="navTxt">Contact Us</h1>
            </Link>
            <Link to="/about" className="link" onClick={handler}>
            <h1 className="navTxt">About Us</h1>
            </Link>
            <Link to="/booking" className="link" onClick={handler}>
              <button className="btnBook">Booking</button>
            </Link>

            <MdCancel id="cancel" onClick={handler} />
          </div>
          <div className="hamburger">
            <GiHamburgerMenu className="ham" onClick={handler} />
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
